<p-toast></p-toast>
<app-navigation>
  <router-outlet></router-outlet>
</app-navigation>
